export default __webpack_public_path__ + "static/Hack-Regular-f66c158ab239b8b6b2593da7460760aa.woff";